import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ROUTE from 'constants/route';
import {
  ITenantFetchPayload,
  CoreState,
  IAlertPayload,
  ISetMessageAction,
  TenantDetailsSucceededAction,
} from './interface';
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-param-reassign */

export const initialState: CoreState = {
  enterprise: {
    id: '',
    name: '',
    logo: '',
    entLogo: '',
    email: '',
    facebookUrl: null,
    instagramUrl: null,
    linkedinUrl: null,
    youtubeUrl: null,
    twitterUrl: null,
    categories: [],
    exchange_rates: {
      USD: 1,
      AUD: 1,
      GBP: 1,
    },
    skills: [],
    active: false,
    termsAndConditionsPage: {
      link: '',
    },
  },
  theme: {
    isFontDefault: true,
    colors: {
      primaryColor: '#171772',
      secondaryColor: '#3DCC96',
    },
    bodyFont: {
      name: 'Urbanist',
      url: '',
    },
    headerFont: {
      name: 'Urbanist',
      url: '',
    },
    headerTemplate: '1',
  },
  alert: {
    open: false,
    type: 'error',
    message: '',
    btnText: 'OK',
  },
  snack: {
    message: '',
    success: false,
    open: false,
  },
  loading: false,
  notifications: {
    unreadMessages: 0,
  },
  windowIsDisabled: {
    display: false,
    message: '',
  },
};

export const CoreSlice = createSlice({
  name: 'feature/base/core',
  initialState,
  reducers: {
    fetchTenant(state: CoreState, action: PayloadAction<ITenantFetchPayload>) {
      state.loading = true;
    },
    fetchTenantSucceeded(state: CoreState, action: PayloadAction<TenantDetailsSucceededAction>) {
      state.loading = false;
      if (action.payload) {
        state.theme = {
          isFontDefault: action.payload.isFontDefault === 'true',
          colors: action.payload.colors
            ? action.payload.colors
            : {
              primaryColor: '#171772',
              secondaryColor: '#3DCC96',
            },
          bodyFont: action.payload.bodyFont
            ? action.payload.bodyFont
            : {
              name: 'Urbanist',
              url: '',
            },
          headerFont: action.payload.headerFont
            ? action.payload.headerFont
            : {
              name: 'Urbanist',
              url: '',
            },
          headerTemplate: action.payload.headerTemplate ? action.payload.headerTemplate : '1',
        };
        state.enterprise = {
          id: action.payload._id,
          name: action.payload.name,
          email: action.payload.email,
          entLogo: action.payload.entLogoUrl,
          logo: action.payload.webLogoUrl,
          facebookUrl: action.payload.facebookUrl,
          instagramUrl: action.payload.instagramUrl,
          linkedinUrl: action.payload.linkedinUrl,
          youtubeUrl: action.payload.youtubeUrl,
          twitterUrl: action.payload.twitterUrl,
          categories: action.payload.categories ? action.payload.categories : [],
          exchange_rates: action.payload.exchange_rates,
          skills: action.payload.skills,
          active: action.payload.active,
          termsAndConditionsPage: action.payload?.termsAndConditionsPage ?? { link: '' },
        };

        // redirect to the inactive message page if the tenant is inactive
        if (!action.payload.active && !window.location.pathname.includes(ROUTE.NOT_ACTIVE)) {
          window.location.href = ROUTE.NOT_ACTIVE;
        }
        // redirect to the home page if the tenant is active but the user is stil on the
        // inactive or not found message page
        if (action.payload.active && (
          window.location.pathname.includes(ROUTE.NOT_ACTIVE)
          || window.location.pathname.includes(ROUTE.NOT_FOUND)
        )) {
          window.location.href = '/';
        }
      } else if (!window.location.pathname.includes(ROUTE.NOT_FOUND)) {
        window.location.href = ROUTE.NOT_FOUND;
      }
    },
    fetchTenantFailed(state: CoreState, action: PayloadAction<string>) {
      state.loading = false;
      state.enterprise = initialState.enterprise;
      if (!window.location.pathname.includes(ROUTE.NOT_FOUND)) {
        window.location.href = ROUTE.NOT_FOUND;
      }
    },
    displayAlert(state: CoreState, action: PayloadAction<IAlertPayload>) {
      state.alert = { open: true, ...action.payload };
    },
    hideAlert(state: CoreState) {
      state.alert = { ...state.alert, open: false };
    },
    setMessage(state: CoreState, action: PayloadAction<ISetMessageAction>) {
      state.snack.message = action.payload.message;
      state.snack.success = action.payload.success;
      state.snack.open = true;
    },
    closeSnackbar(state: CoreState) {
      state.snack.open = false;
    },
    getNotifications: () => {},
    setNotifications: (state, action: PayloadAction<CoreState['notifications']>) => {
      state.notifications.unreadMessages = action.payload.unreadMessages;
    },
    setWindowsDisabled(state: CoreState, action: PayloadAction<{
      display: boolean;
      message: string;
    }>) {
      state.windowIsDisabled = action.payload;
    },
  },
});

export const { actions: CoreSliceActions } = CoreSlice;
